import { apiRequest } from "./ApiUtility";

export async function getReportData(authContext, data) {
  
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  const url = `/api/reports/report`;
  return await apiRequest("post", url, authContext, data);
}